import {
  PMSmallNumber,
  PMSmallNumberCardEditSchema,
} from "@pimo/pimo-components/src/lib/pm-components";

import { getLocalizedCardCopy } from "../../../utils/get-localized-card-copy";
import {
  getPluralOfProjectName,
  getProjectName,
} from "../../../utils/get-plural-of-project-name";
import { DashboardCardContext } from "../context";

export function addNumberOfProjectsCard(ctx: DashboardCardContext) {
  const { view, language, itemName, itemNamePlural, getCardCopy } = ctx;

  const numberOfProjectsComponent = view.addComponent({
    component: PMSmallNumber,
    layoutProps: {
      componentId: "numberOfProjectsComponent",
      title: "",
      description: "",
      labels: ["#ofProjects"],
      editSchema: PMSmallNumberCardEditSchema,
    },
  });

  numberOfProjectsComponent.mapLayoutProps(() => {
    return {
      componentId: "numberOfProjectsComponent",
      labels: ["#ofProjects"],
      description: getCardCopy(language, "numberOfProjects").description,
      title: getCardCopy(language, "numberOfProjects").title,
      editSchema: PMSmallNumberCardEditSchema,
    };
  });

  numberOfProjectsComponent.mapState(({ dashboard, settings, language }) => {
    return {
      showInfoIcon: false,
      showMenuIcon: false,
      title: getLocalizedCardCopy(language, "numberOfProjects", {
        itemName,
        itemNamePlural,
        projectName: getProjectName(
          settings?.configuration?.projectName,
          language
        ),
        projectNamePlural: getPluralOfProjectName(
          settings?.configuration?.projectName,
          language
        ),
      }).title,
      number: (dashboard?.projects ?? []).length ?? 0,
    };
  });
}
